import { useSelector } from "react-redux";
import GuardWithPermissions from "@wine2trace/auth/RequireAuth";
import usePermissions from "../hooks/usePermissions";
import { selectActiveWinery, selectUserRbacLoadedFor } from "../context/selectors";
import Loader from "./Loader";

// Route guard of @wine2trace/auth with the permissions of the user in the active winery.
//   allowedRoles   the account types that can open the group (ADMIN has no bypass: list ROLES.ADMIN).
//   permission     [resource, action] or an array of such pairs (any-of), checked with
//                  usePermissions().can (the effective map: what the server allows).
//   allowWithoutWinery  the route works with no active winery (the first winery is created with none;
//                  the BE allows it): the permission is not asked in that case.
// The verdict waits (a loader, never /unauthorized) until GET /users/me/rbac has answered for the
// active winery, or has failed for it (then nothing is granted and /unauthorized shows). With no active
// winery the permissions are not there to read: the loader stays, the winery selection is elsewhere
// (the Home modal, PersistentLogin).
const RequireAuth = ({ permission, allowWithoutWinery = false, ...props }) => {
  const { can } = usePermissions();
  const activeWinery = useSelector(selectActiveWinery);
  const loadedFor = useSelector(selectUserRbacLoadedFor);

  const wineryId = activeWinery?.id ?? null;
  const skipPermission = allowWithoutWinery && wineryId === null;

  return (
    <GuardWithPermissions
      {...props}
      permission={skipPermission ? undefined : permission}
      canAccess={can}
      ready={wineryId !== null && loadedFor === wineryId}
      fallback={<Loader />}
    />
  );
};

export default RequireAuth;
